export enum ADMIN_SETUP_STEPS {
  SETUP_PAYROLL = 1,
  CONNECT_BANK = 2,
}

export const ADMIN_SETUP_STEPS_NUMBER = Object.keys(ADMIN_SETUP_STEPS).length / 2;

export const ADMIN_SETUP_HIGHLIGHTED_AGREEMENT_SECTION_CLASS_NAME = "highlighted";
